
const cache = {
  state: {
    cacheUserQuery: '', // 系统用户
    cacheRoleQuery: '', // 角色管理
    cacheRegionalQuery: '', // 区域管理

    cacheWorkerQuery: '', // 社工管理
    cacheVolunteerQuery: '', // 自愿者
    cacheCustomerQuery: '', // 服务对象管理
    cacheRecordQuery: '', // 服务记录
    cacheCategoryQuery: '', // 服务类目

    cacheRestoreQuery: '', // 回收站
    cacheCustomerLogQuery: '' ,// 服务对象服务

    cacheActivityQuery: '',  // 活动管理
    cacheNewsQuery: '', // 资讯管理
    cacheNoticeQuery: '', // 通知管理
    cacheRecruitQuery: '' ,// 招聘
    cacheCompanyAuthQuery: ''
  },
  mutations: {
    CACHE_USER: (state, param) => {
      state.cacheUserQuery = param
    },
    CACHE_ROLE: (state, param) => {
      state.cacheRoleQuery = param
    },
    CACHE_REGIONAL: (state, param) => {
      state.cacheRegionalQuery = param
    },

    CACHE_WORKER: (state, param) => {
      state.cacheWorkerQuery = param
    },
    CACHE_CUSTOMER: (state, param) => {
      state.cacheCustomerQuery = param
    },
    CACHE_RECORD: (state, param) => {
      state.cacheRecordQuery = param
    },
    CACHE_CATEGORY: (state, param) => {
      state.cacheCategoryQuery = param
    },
    CACHE_RESTORE: (state, param) => {
      state.cacheRestoreQuery = param
    },
    CACHE_CUSTOMERLOG: (state, param) => {
      state.cacheCustomerLogQuery = param
    },
    CACHE_ACTIVITY: (state, param) => {
      state.cacheActivityQuery = param
    },
    CACHE_NEWS: (state, param) => {
      state.cacheNewsQuery = param
    },
    CACHE_NOTICE: (state, param) => {
      state.cacheNoticeQuery = param
    },
    CACHE_RECRUIT: (state, param) => {
      state.cacheRecruitQuery = param
    },
    CACHE_VOLUNTEER: (state, param) => {
      state.cacheVolunteerQuery = param
    },
    CACHE_COMPANYAUTH: (state, param) => {
      state.cacheCompanyAuthQuery = param
    },
  }
}

export default cache
